const getColor = (property: string) =>
    getComputedStyle(document.documentElement).getPropertyValue(property).trim()

/********* PRIMARY *********/
export const colorPrimaryExtraDark = getColor('--color-primary-extra-dark')
export const colorPrimaryDark = getColor('--color-primary-dark')
export const colorPrimary = getColor('--color-primary')
export const colorPrimaryLight = getColor('--color-primary-light')
export const colorPrimaryExtraLight = getColor('--color-primary-extra-light')

/********* ACCENT *********/
export const colorAccentExtraDark = getColor('--color-accent-extra-dark')
export const colorAccentDark = getColor('--color-accent-dark')
export const colorAccent = getColor('--color-accent')
export const colorAccentMedium = getColor('--color-accent-medium')
export const colorAccentLight = getColor('--color-accent-light')
export const colorAccentExtraLight = getColor('--color-accent-extra-light')

/********* SEMANTIC *********/
export const colorError = getColor('--color-error')
export const colorErrorLight = getColor('--color-error-light')
export const colorErrorDark = getColor('--color-error-dark')
export const colorCaution = getColor('--color-caution')
export const colorCautionDark = getColor('--color-caution-dark')
export const colorCautionLight = getColor('--color-caution-light')
export const colorSuccess = getColor('--color-success')
export const colorSuccessLight = getColor('--color-success-light')
export const colorSuccessDark = getColor('--color-success-dark')
export const colorWhite = getColor('--color-white')

/********* LANDING PAGE  *********/
export const colorPeacock = getColor('--color-peacock')
export const colorBotticelli = getColor('--color-botticelli')
export const colorAliceBlue = getColor('--color-alice-blue')
export const colorWhiteLight = getColor('--color-white-light')
